import styled from 'styled-components';
import { NavLink } from 'react-router-dom';

const PRIMARY_COLOR = '#4948ac';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%
  padding: 20px;
  background-color: #f4f4f4;
`;

export const PageTitle = styled.h1`
  font-size: 3rem;
  color: #1a1a32;
  font-weight: 600;
  margin-bottom: 20px;
`;

export const ScreenHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const SearchLink = styled.span`
  font-size: 14px;
  color: ${PRIMARY_COLOR};
  cursor: pointer;
`;

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  padding: 20px 40px;
  max-height: auto;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
`;

export const Separator = styled.div`
  min-height: 30px;
`;

export const CardHeader = styled.div`
  width: 100%;
  display: flex;
  margin-bottom: 20px;
  justify-content: space-between;
  align-items: center;
`;

export const CardTitle = styled.h3`
  min-width: max-content;
  margin: 0 40px 0 0;
  font-size: 2.4rem;
  color: #17191c;
  font-weight: 600;
`;

export const LeftHeader = styled.div`
  display: flex;
  align-items: center;
`;

export const DropdownWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 10px;
`;

export const RightHeader = styled.div`
  width: 60%;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  max-height: auto;
`;

export const HelpForm = styled.div`
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  width: 100%;
  gap: 0px;
  justify-content: center;
  max-height: auto;
`;

export const RegularText = styled.span`
  font-size: 1.6rem;
`;

export const Input = styled.input`
  padding: 10px;
  font-size: 1.6rem;
  border: 1px solid #ccc;
  border-radius: 4px; /* Rounded corners for input */
  transition: border-color 0.3s;

  &:focus {
    border-color: #007bff; /* Highlight border on focus */
    outline: none; /* Remove default outline */
  }
`;

export const RegularButton = styled.button`
  padding: 10px 20px;
  font-size: 1.6rem;
  color: #fff;
  background-color: #007bff; /* Primary button color */
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
  margin-top: 10px;
`;

export const FormInputWrapper = styled.div`
  flex: 0 0 calc(33.33% - 20px);
  max-height: 250px;
  overflow: hidden;
  margin-bottom: 0px;

  p {
    margin: 0; /* Remove default paragraph margin */
  }

  input,
  select {
    border: 0.5px solid #222247;
    border-radius: 7px;
    opacity: 1;
    height: 40px; /* Adjust height to fit wrapper */
    box-sizing: border-box; /* Include padding and borders in height */
    width: 100%; /* Ensure full width */
  }

  input:disabled {
    background: #f3f4f8; /* Background for disabled inputs */
  }

  select {
    width: 100%; /* Ensure select takes full width */
  }
`;

export const NavTextLink = styled(NavLink)`
  align-self: center;
  text-decoration: none;
  color: black;
  &.active {
    color: #2dcafc;
  }
`;

export const ArrowBack = styled.img`
  height: 25px;
  width: auto;
`;

export const HeaderItemLeft = styled.div`
  display: flex;
  align-items: center;
  column-gap: 15px;
  @media only screen and (max-width: 1000px) {
    display: flex;
    justify-content: space-between;
  }
`;

export const ModuleLine = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;

  select {
    min-width: 100%;
  }
`;

export const SubText = styled.div`
  font-size: 14px;
  color: ${PRIMARY_COLOR};
  margin-bottom: 24px;
`;

export const ReadOnlyDiv = styled.div`
  border: 1px solid #ccc;
  border-radius: 7px;
  height: 35px;
  width: 100%;

  padding: 2px 10px;
  box-sizing: border-box;

  display: flex;
  align-items: center;

  font-size: 1.5rem;
  color: #17191c;
  background: #ffffff;

  user-select: text;
  cursor: default;
`;
